import { ShieldCheck } from "lucide-react";

export const SupervisorBadge = ({ employee, className = "" }) =>
  employee?.is_supervisor ? (
    <span data-testid={`supervisor-badge-${employee.id}`} title="مشرف داخلي"
      className={`inline-flex items-center gap-0.5 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 text-[10px] font-semibold px-1.5 py-0.5 whitespace-nowrap ${className}`}>
      <ShieldCheck className="h-2.5 w-2.5" /> مشرف داخلي
    </span>
  ) : null;
